module.exports = __webpack_public_path__ + "assets/img/c2.290e20ce.jpg";